(function(){
  function run(){
    var main=document.querySelector('main[data-template]'); if(!main) return;
    if((main.dataset.template||'').indexOf('product')===-1) return;
    if(location.search.indexOf('variant=')!==-1) return;
    var vs=document.querySelector('variant-selects, variant-radios'); if(!vs) return;
    var targets=['adult m','m','medium']; var done=false;
    vs.querySelectorAll('fieldset').forEach(function(fs){
      if(done) return; var lg=fs.querySelector('legend'); var nm=lg?lg.textContent.toLowerCase():'';
      if(nm.indexOf('size')===-1) return;
      for(var t=0;t<targets.length&&!done;t++){
        var rs=fs.querySelectorAll('input[type=radio]');
        for(var i=0;i<rs.length;i++){ if(rs[i].value.trim().toLowerCase()===targets[t]){ if(!rs[i].checked){rs[i].checked=true; rs[i].dispatchEvent(new Event('change',{bubbles:true}));} done=true; break; } }
      }
    });
    if(!done){ vs.querySelectorAll('select').forEach(function(sel){
      if(done) return; var nm=(sel.name||'').toLowerCase(); if(nm.indexOf('size')===-1) return;
      for(var t=0;t<targets.length&&!done;t++){ for(var i=0;i<sel.options.length;i++){ if(sel.options[i].value.trim().toLowerCase()===targets[t]){ if(sel.selectedIndex!==i){sel.selectedIndex=i; sel.dispatchEvent(new Event('change',{bubbles:true}));} done=true; break; } } }
    }); }
  }
  function boot(){ setTimeout(run,300); setTimeout(run,900); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
